class BlogProductShortcodes {
  constructor(root) {
    this.root = root;
    this.pattern = /\[product\s+handle=["']([^"']+)["'](?:\s+layout=["']([^"']+)["'])?\]/g;
  }

  init() {
    const walker = document.createTreeWalker(this.root, NodeFilter.SHOW_TEXT);
    const matches = [];
    let node;
    while ((node = walker.nextNode())) {
      if (this.pattern.test(node.nodeValue)) matches.push(node);
      this.pattern.lastIndex = 0;
    }
    matches.forEach((textNode) => this.replaceNode(textNode));
  }

  replaceNode(textNode) {
    const text = textNode.nodeValue;
    const parent = textNode.parentNode;
    let lastIndex = 0;
    let match;
    this.pattern.lastIndex = 0;

    while ((match = this.pattern.exec(text))) {
      const [full, handle, layout] = match;
      if (match.index > lastIndex) {
        parent.insertBefore(document.createTextNode(text.slice(lastIndex, match.index)), textNode);
      }
      parent.insertBefore(this.renderPlaceholder(handle, layout), textNode);
      lastIndex = match.index + full.length;
    }

    if (lastIndex < text.length) {
      parent.insertBefore(document.createTextNode(text.slice(lastIndex)), textNode);
    }
    parent.removeChild(textNode);
  }

  renderPlaceholder(handle, layout) {
    const placeholder = document.createElement('div');
    placeholder.className = 'blog-product-embed blog-product-embed--loading';
    if (layout === 'compact') placeholder.classList.add('blog-product-embed--compact');
    this.fetchCard(handle, layout, placeholder);
    return placeholder;
  }

  fetchCard(handle, layout, placeholder) {
    fetch(`/products/${handle}?section_id=card-product-embed`)
      .then((response) => {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const card = doc.querySelector('.blog-product-embed');
        if (!card) throw new Error('missing card markup');
        if (layout === 'compact') card.classList.add('blog-product-embed--compact');
        placeholder.replaceWith(card);
        card.dispatchEvent(new CustomEvent('blog-product-embed:loaded', { bubbles: true }));
      })
      .catch(() => placeholder.remove());
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-shoppable-article]').forEach((root) => {
    new BlogProductShortcodes(root).init();
  });
});
